// 「カメラ機種に対して」Teleportパッケージ対応かどうかの認可を行う
const operation = {
    'IB9360-H': true,
    'FD9367-EHTV-v2': true,
}

// どのカメラ機種がTeleportパッケージに対応しているか確認する
const vivotekTeleportCheck = (cameraType) => {
    if(cameraType != "") {
        // Teleport対応欄に追加されていない機種であればfalseで返す
        if (operation[cameraType] == undefined) {
            return false
        }
        return operation[cameraType]
    } else {
        return false;
    }
}

export default vivotekTeleportCheck
